import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '../../assets/receipt-icon.png'


const _hoisted_1 = {
  key: 0,
  class: "pdf-preview-modal"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", null, "Cost", -1)

import { computed, ref } from "vue";
import * as rules from "@/utils/rules";
import DateInput from "../custom/DateInput.vue";
import Item from "@/types/FsaItem";
import FormTitle from "../common/FormTItle.vue";
import PreviewPdf from "../custom/PreviewPdf.vue";
import TextInput from "../custom/TextInput.vue";
import CurrencyInput from "../custom/CurrencyInput.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ClaimInformationForm',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;



const receipt = ref<string | null>(null);
const isPdf = ref(false);

const items = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

const onClickViewReceipt = (url: string) => {
  receipt.value = url;
  isPdf.value = url.includes("application/pdf");
};

const clearReceipt = () => {
  receipt.value = null;
};

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, {
        cols: "12",
        class: "pb-0"
      }, {
        default: _withCtx(() => [
          _createVNode(FormTitle, {
            title: "Claim Information",
            description: "Give us some information about the reimbursement claim"
          })
        ]),
        _: 1
      }),
      (receipt.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (clearReceipt()))
              }, [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [
                    _createTextVNode("mdi-close")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", null, [
                (isPdf.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (receipt.value)
                        ? (_openBlock(), _createBlock(PreviewPdf, {
                            key: 0,
                            "pdf-url": receipt.value
                          }, null, 8, ["pdf-url"]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: receipt.value,
                      alt: "receipt",
                      style: {"object-fit":"contain","width":"100%"}
                    }, null, 8, _hoisted_2))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, i) => {
        return (_openBlock(), _createBlock(_component_v_col, {
          cols: "12",
          key: i
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, { class: "pa-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "d-flex justify-space-between align-center"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("h2", null, "Item " + _toDisplayString(i + 1), 1),
                        _createElementVNode("img", {
                          class: "preview-receipt-icon",
                          src: _imports_0,
                          onClick: ($event: any) => (onClickViewReceipt(item.fileUrl!))
                        }, null, 8, _hoisted_3),
                        _createElementVNode("button", {
                          type: "button",
                          class: "preview-receipt-btn",
                          onClick: ($event: any) => (onClickViewReceipt(item.fileUrl!))
                        }, [
                          _hoisted_5,
                          _createTextVNode(" Preview receipt ")
                        ], 8, _hoisted_4)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(TextInput, {
                          "bg-color": '#FAFBFC',
                          variant: "outlined",
                          label: "Item Name",
                          modelValue: item.name,
                          "onUpdate:modelValue": ($event: any) => ((item.name) = $event),
                          rules: [rules.requiredRule]
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "12",
                      md: "6",
                      lg: "6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(TextInput, {
                          "bg-color": '#FAFBFC',
                          variant: "outlined",
                          label: "Purchased From",
                          modelValue: item.provider,
                          "onUpdate:modelValue": ($event: any) => ((item.provider) = $event),
                          rules: [rules.requiredRule]
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "12",
                      md: "6",
                      lg: "6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(DateInput, {
                          color: "'#FAFBFC'",
                          variant: "outlined",
                          label: "Purchase date",
                          modelValue: item.date,
                          "onUpdate:modelValue": ($event: any) => ((item.date) = $event),
                          rules: [rules.requiredRule]
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "py-0"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "12",
                      md: "2",
                      lg: "2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(CurrencyInput, {
                          class: "item-input",
                          modelValue: item.cost,
                          "onUpdate:modelValue": ($event: any) => ((item.cost) = $event),
                          rules: [rules.requiredRule]
                        }, {
                          "prepend-inner": _withCtx(() => [
                            _createTextVNode("$")
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue", "rules"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }))
}
}

})